import { gql } from 'graphql-request'

export const GlobalNewsPageQuery = gql`
  query GlobalNewsPage(
    $locale: LocaleInputType!
    $isPreview: Boolean! = false
  ) {
    NewsPage(locale: $locale, draft: $isPreview) {
      title
    }
  }
`
